import { useSelector } from "../../../../../../../redux/hooks";
import {
  StyledTable,
  StyledTd,
  StyledTh,
  StyledTr,
} from "../../../../../../../styled";
import MedicalInputGroup from "../../Inputs/MedicalInputGroup";
import {
  StyledMedicalContent,
  StyledMedicalContentLabel,
} from "../../MedicalHistory.styled";
import MedicalSectionWrapper from "../MedicalSectionWrapper";
import dayjs from "dayjs";
import MedicalLeaveHistoryRow from "./MedicalLeaveHistoryRow";
import { useEffect } from "react";

const MedicalLeaveHistory = () => {
  const { medLeaveHistory, inputs } = useSelector(
    state => state.medicalHistory.leaveHistory,
  );
  // const map
  return (
    <MedicalSectionWrapper name="Medical Leave History">
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}>
        <div>
          {medLeaveHistory.list && (
            <StyledTable>
              <thead>
                <StyledTr>
                  <StyledTh>Date</StyledTh>
                  <StyledTh>Status</StyledTh>
                  <StyledTh>Action</StyledTh>
                </StyledTr>
              </thead>
              <tbody>
                {medLeaveHistory.list?.map((data, i) => (
                  <MedicalLeaveHistoryRow
                    key={`leave-${data.leaveid}-${i}`}
                    {...data}
                  />
                ))}
              </tbody>
            </StyledTable>
          )}
        </div>
        <div>
          <StyledMedicalContentLabel>
            Total this period:
          </StyledMedicalContentLabel>
          <StyledMedicalContent>
            <StyledMedicalContentLabel>Onboard: </StyledMedicalContentLabel>
            <p style={{ margin: 0 }}>{medLeaveHistory.daysOnBoard} days</p>
          </StyledMedicalContent>
          <StyledMedicalContent>
            <StyledMedicalContentLabel>Leave: </StyledMedicalContentLabel>
            <p style={{ margin: 0 }}>{medLeaveHistory.daysOffLeave} days</p>
          </StyledMedicalContent>
        </div>
        <MedicalInputGroup inputs={inputs} />
      </div>
    </MedicalSectionWrapper>
  );
};
export default MedicalLeaveHistory;
